import { render, staticRenderFns } from "./split.vue?vue&type=template&id=55fb536a&scoped=true"
import script from "./split.ts?vue&type=script&lang=js&external"
export * from "./split.ts?vue&type=script&lang=js&external"
import style0 from "./split.vue?vue&type=style&index=0&id=55fb536a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fb536a",
  null
  
)

export default component.exports